export default {
    recognizeImage(image) {
        const formData = new FormData();
        formData.append('file', image)
        return axios.post('/ocr/recognize', formData)
    }
}